import { render, staticRenderFns } from "./CRMBillDetails.vue?vue&type=template&id=1cf5ee9e&scoped=true"
import script from "./CRMBillDetails.vue?vue&type=script&lang=js"
export * from "./CRMBillDetails.vue?vue&type=script&lang=js"
import style0 from "./CRMBillDetails.vue?vue&type=style&index=0&id=1cf5ee9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf5ee9e",
  null
  
)

export default component.exports